import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

function LoginGuard(to, from, next) {
  let exp_date = new Date(localStorage.getItem("expires"));
  console.log(exp_date);
  if (
    exp_date.getTime() < new Date().getTime() ||
    localStorage.getItem("login") != "true"
  ) {
    // 로그인 페이지로 이동
    alert("유효하지 않은 접근 입니다.");
    next("/login");
  } else {
    next();
  }
}

export default new Router({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      };
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  },

  routes: [
    {
      path: "/shop",
      name: "book_store",
      component: () => import("@/SPA/Shop/Shop.vue")
    },
    {
      path: "/shop/:id",
      name: "shop_detail",
      component: () => import("@/SPA/Shop/ShopDetail.vue")
    },
    {
      path: "/",
      name: "index",
      component: () => import("@/SPA/Main/Main.vue")
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/SPA/Login/Login.vue")
    },
    {
      path: "/popcon_contents",
      name: "popcon_contents",
      component: () => import("@/SPA/PopconContent/PopconContent.vue")
    },
    {
      path: "/popcon_textile_contents",
      name: "popcon_textile_contents",
      component: () => import("@/SPA/PopconTextileContent/PopconTextileContent.vue")
    },
    {
      path: "/password_change",
      name: "password_change",
      component: () => import("@/SPA/PasswordChange/PasswordChange.vue")
    },
    {
      path: "/signup",
      name: "signup",
      component: () => import("@/SPA/Signup/Signup.vue")
    },
    {
      path: "/find_id",
      name: "find_id",
      component: () => import("@/SPA/FindId/FindId.vue")
    },

    {
      path: "/community",
      component: () => import("@/SPA/Community/Community.vue"),
      children: [
        {
          path: "detail/:id",
          component: () =>
            import("@/SPA/Community/Components/CommunityDetail.vue")
        },
        {
          path: ":category/write",
          name: "community_write",
          component: () =>
            import("@/SPA/Community/Components/CommunityWrite.vue")
        },
        {
          path: "",
          name: "community_list",
          component: () =>
            import("@/SPA/Community/Components/CommunityList.vue"),
          children: [
            {
              path: ":category",
              component: () =>
                import("@/SPA/Community/Components/CommunityList.vue"),
              children: [
                {
                  path: ":page",
                  component: () =>
                    import("@/SPA/Community/Components/CommunityList.vue")
                }
              ]
            }
          ]
        }
      ]
    },
    {
      path: "/image_detect",
      name: "image_detect",
      component: () => import("@/SPA/ImageDetect/ImageDetect.vue")
    },
    {
      path: "/search",
      name: "search",
      component: () => import("@/SPA/Search/Search.vue")
    },
    {
      path: "/search_partner",
      name: "search_partner",
      component: () => import("@/SPA/Search/SearchPartner.vue")
    },
    {
      path: "/search_service",
      name: "search_service",
      component: () => import("@/SPA/Search/SearchService.vue")
    },
    {
      path: "/search_popsign",
      name: "search_popsign",
      component: () => import("@/SPA/Search/SearchPopsign.vue")
    },
    {
      path: "/search_textile",
      name: "search_textile",
      component: () => import("@/SPA/Search/SearchTextile.vue")
    },
    {
      path: "/design",
      name: "design",
      component: () => import("@/SPA/Design/Design.vue")
    },
    {
      path: "/design/:id",
      name: "design_detail",
      component: () => import("@/SPA/Design/DesignDetail.vue")
    },
    {
      path: "/product",
      name: "product_list",
      component: () => import("@/SPA/Product/Product.vue")
    },
    {
      path: "/product/:id",
      name: "product_detail",
      component: () => import("@/SPA/ProductDetail/ProductDetail.vue")
    },
    {
      path: "/used_product",
      name: "used_product_list",
      component: () => import("@/SPA/UsedProduct/Product.vue")
    },
    {
      path: "/used_product/:id",
      name: "used_product_detail",
      component: () => import("@/SPA/UsedProductDetail/ProductDetail.vue")
    },
    {
      path: "/youtube",
      name: "youtube",
      component: () => import("@/SPA/Youtube/Youtube.vue")
    },
    {
      path: "/gallery",
      name: "gallery",
      component: () => import("@/SPA/Gallery/Gallery.vue")
    },
    {
      path: "/mypage",
      name: "mypage",
      component: () => import("@/SPA/MyPage/MyPageMain/MyPageMain.vue"),
      children: [
        {
          path: "",
          name: "main",
          component: () => import("@/SPA/MyPage/MyPageMain/MyPageMain.vue")
        },
        {
          path: "inquiry",
          name: "content-inquiry",
          component: () => import("@/SPA/MyPage/Inquiry/Inquiry.vue")
        },
        {
          path: "inquiry/:id",
          name: "content-inquiry-detail",
          component: () => import("@/SPA/MyPage/Inquiry/InquiryDetail.vue")
        },
        {
          path: "account",
          name: "account",
          component: () => import("@/SPA/MyPage/Account/Account.vue")
        },
        {
          path: "matching",
          name: "account",
          component: () => import("@/SPA/MyPage/Matching/Matching.vue")
        },
        {
          path: "exhibition",
          name: "exhibition",
          component: () => import("@/SPA/MyPage/Exhibition/Exhibition.vue")
        },
        {
          path: "event",
          name: "event",
          component: () => import("@/SPA/MyPage/Event/Event.vue")
        },
        {
          path: "event/:id",
          name: "event_detail",
          component: () => import("@/SPA/MyPage/Event/EventDetail.vue")
        },
        {
          path: "bidding",
          name: "account",
          component: () => import("@/SPA/MyPage/Bidding/Bidding.vue")
        },
        {
          path: "community",
          name: "content-service",
          component: () => import("@/SPA/MyPage/Community/Community.vue")
        },
        {
          path: "service",
          name: "content-service",
          component: () => import("@/SPA/MyPage/Service/Service.vue")
        },
        {
          path: "content",
          name: "content-mypage",
          component: () => import("@/SPA/MyPage/Content/Content.vue")
        },
        {
          path: "basket",
          name: "basket-mypage",
          component: () => import("@/SPA/MyPage/Basket/Basket.vue")
        },
        {
          path: "order",
          name: "order-mypage",
          component: () => import("@/SPA/MyPage/Order/Order.vue")
        }
      ]
    },

    {
      path: "/partner_mypage",
      name: "partner_mypage",
      component: () => import("@/SPA/PartnerMyPage/PartnerMyPage.vue"),
      children: [
        {
          path: "partner_projects",
          name: "partner_projects",
          component: () =>
            import("@/SPA/PartnerMyPage/Components/Projects/Project.vue")
        },
        {
          path: "partner_report",
          name: "partner_report",
          component: () =>
            import(
              "@/SPA/PartnerMyPage/Components/PartnerReport/PartnerReport.vue"
            )
        },
        {
          path: "campaign_report",
          name: "campaign_report",
          component: () =>
            import(
              "@/SPA/PartnerMyPage/Components/PartnerReport/CampaignReport.vue"
            )
        },
        {
          path: "matching",
          name: "account",
          component: () => import("@/SPA/MyPage/Matching/Matching.vue")
        },
        {
          path: "exhibition",
          name: "exhibition",
          component: () => import("@/SPA/MyPage/Exhibition/Exhibition.vue")
        },
        {
          path: "service",
          name: "content-service",
          component: () => import("@/SPA/MyPage/Service/Service.vue")
        },
        {
          path: "content",
          name: "content-mypage",
          component: () => import("@/SPA/MyPage/Content/Content.vue")
        },
        {
          path: "contents_report",
          name: "content_report",
          component: () =>
            import(
              "@/SPA/PartnerMyPage/Components/PartnerReport/ContentReport.vue"
            )
        },
        {
          path: "service_report",
          name: "service_report",
          component: () =>
            import(
              "@/SPA/PartnerMyPage/Components/PartnerReport/ServiceReport.vue"
            )
        },
        {
          path: "inquiry",
          name: "inquiry_manage",
          component: () => import("@/SPA/PartnerMyPage/Inquiry/Inquiry.vue")
        },
        {
          path: "inquiry/:id",
          name: "inquiry_manage",
          component: () =>
            import("@/SPA/PartnerMyPage/Inquiry/InquiryDetail.vue")
        },
        {
          path: "account",
          name: "partner_account",
          component: () => import("@/SPA/PartnerMyPage/Account/Account.vue")
        },
        {
          path: "event",
          name: "company_event",
          component: () => import("@/SPA/PartnerMypage/Event/Event.vue")
        },
        {
          path: "event/detail/:id",
          name: "company_event_detail",
          component: () => import("@/SPA/PartnerMypage/Event/EventDetail.vue")
        },
        {
          path: "event/add",
          name: "company_event_add",
          component: () => import("@/SPA/PartnerMypage/Event/EventAdd.vue")
        }
      ]
    },

    {
      path: "/bidding",
      name: "bidding",
      component: () => import("@/SPA/Bidding/Bidding.vue")
    },
    {
      path: "/bidding/:id",
      name: "bidding_detail",
      component: () => import("@/SPA/Bidding/BiddingDetail.vue")
    },
    {
      path: "/exhibition",
      name: "exhibition",
      component: () => import("@/SPA/Exhibition/Exhibition.vue")
    },
    {
      path: "/kosign",
      name: "kosign",
      component: () => import("@/SPA/Kosign/Kosign.vue")
    },
    {
      path: "/exhibition/:id",
      name: "exhibition_detail",
      component: () => import("@/SPA/Exhibition/ExhibitionDetail.vue")
    },
    {
      path: "/notice",
      name: "notice",
      component: () => import("@/SPA/Notice/Notice.vue")
    },
    {
      path: "/faq",
      name: "faq",
      component: () => import("@/SPA/FAQ/FAQ.vue")
    },
    {
      path: "/popcon_partner_apply",
      name: "popcon_partner_apply",
      component: () => import("@/SPA/PopconPartnerApply/PopconPartnerApply.vue")
    },
    {
      path: "/service_inform/:id",
      name: "service_inform",
      component: () => import("@/SPA/ServiceInform/ServiceInform.vue")
    },
    {
      path: "/contact_us",
      name: "contact_us",
      component: () => import("@/SPA/ContactUs/ContactUs.vue")
    },
    {
      path: "/apply",
      name: "apply",
      component: () => import("@/SPA/Apply/Apply.vue")
    },
    {
      path: "/bidding_add",
      name: "bidding_add",
      component: () => import("@/SPA/BiddingAdd/BiddingAdd.vue")
    },
    {
      path: "/popcon_introduction",
      name: "popcon_introduction",
      component: () => import("@/SPA/PopconIntroduction/PopconIntroduction.vue")
    },
    {
      path: "/detail_portfolio/:portfolio_id",
      name: "company_portfolio_detail",
      component: () => import("@/SPA/Company/Portfolio/PortfolioPopup.vue")
    },
    {
      path: "/company/:id",
      name: "company",
      component: () => import("@/SPA/Company/Company.vue"),
      children: [
        {
          path: "info",
          name: "company_info",
          component: () => import("@/SPA/Company/Info/Info.vue")
        },
        {
          path: "qna",
          name: "company_qna",
          component: () => import("@/SPA/Company/QnA/QnA.vue")
        },
        {
          path: "intro",
          name: "company_intro",
          component: () => import("@/SPA/Company/Intro/Intro.vue")
        },
        
        

        {
          path: "portfolio",
          name: "company_portfolio",
          component: () => import("@/SPA/Company/Portfolio/Portfolio.vue")
        },

        {
          path: "review",
          name: "company_review",
          component: () => import("@/SPA/Company/Review/Review.vue")
        },
        {
          path: "event",
          name: "company_event",
          component: () => import("@/SPA/Company/Event/Event.vue")
        },
        {
          path: "event/:event_id",
          name: "company_event",
          component: () => import("@/SPA/Company/Event/EventDetail.vue")
        },
        {
          path: "downloads",
          name: "company_download",
          component: () => import("@/SPA/Company/Downloads/Downloads.vue")
        },

        {
          path: "downloads/:file_id",
          name: "company_downdload_file",
          component: () => import("@/SPA/Company/Downloads/DownloadDetail.vue")
        }
      ]
    },
    {
      path: "/contents",
      name: "contents",
      component: () => import("@/SPA/Contents/Contents.vue"),
      children: [
        {
          path: ":id",
          component: () => import("@/SPA/Contents/Contents.vue")
        }
      ]
    },
    {
      path: "/matching",
      name: "matching",
      component: () => import("@/SPA/CompanyList/CompanyList.vue"),
      children: [
        {
          path: "/:tag",
          component: () => import("@/SPA/CompanyList/CompanyList.vue")
        }
      ]
    },

    {
      path: "/find_account",
      name: "find_account",
      component: () => import("@/SPA/FindAccount/FindAccount.vue")
    },

    {
      path: "/m",
      name: "mobile",
      component: () => import("@/Mobile/SPA/Index.vue"),
      children: [
        {
          path: "",
          name: "mobile_index",
          component: () => import("@/Mobile/SPA/Main/Main.vue")
        },
        {
          path: "login",
          name: "mobile_login",
          component: () => import("@/Mobile/SPA/Login/Login.vue")
        },
        {
          path: "signup",
          name: "mobile_signup",
          component: () => import("@/Mobile/SPA/Signup/Signup.vue")
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js